const initialState = {
  login: false,
  signup: false,
  noMoney: false,
  verifyPhone: false,
  testQuestionTextExplanation: false,
  testQuestionVideoExplanation: false,
  confirmPhone: false,
  confirmEmail: false,
  languageModal: false,
  confirmLanguageModal: false,
  notificationModal: false,
  paymentServiceSelectModal: false,
  checkSettingsModal: false,
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SET_LOGIN_MODAL":
      return { ...initialState, login: action.open };
    case "SET_CONFIRM_EMAIL_MODAL":
      return { ...initialState, confirmEmail: action.open };
    case "SET_CONFIRM_PHONE_MODAL":
      return { ...initialState, confirmPhone: action.open };

    case "SET_NO_MONEY_MODAL":
      return { ...initialState, noMoney: action.open };
    case "SET_CHECK_SETTINGS_MODAL":
      return { ...initialState, checkSettingsModal: action.open };
    case "SET_TEST_QUESTION_TEXT_EXPLANATION_MODAL":
      return { ...initialState, testQuestionTextExplanation: action.open };
    case "SET_TEST_QUESTION_VIDEO_EXPLANATION_MODAL":
      return { ...initialState, testQuestionVideoExplanation: action.open };
    case "SET_CONFIRM_LANGUAGE_MODAL":
      return { ...initialState, confirmLanguageModal: action.open };
    case "SET_LANGUAGE_MODAL":
      return { ...initialState, languageModal: action.open };
    case "SET_NOTIFICATION_MODAL":
      return { ...initialState, notificationModal: action.open };
    case "SET_PAYMENT_SERVICE_SELECT_MODAL":
      return { ...initialState, paymentServiceSelectModal: action.open };
    case "NO_MODAL":
      return initialState;
    default:
      return initialState;
  }
}
